<template>
  <div class="question">
    <headers class="herderNav" ref="header" :isChange="false" />
    <div class="questionCon">
      <div class="questionTips">
        <div class="questionTipsTit">
          <p>{{ dryRun[0].title }}</p>
        </div>
        <!-- <div class="questionProposal">{{dryRun[0].info}}</div> -->
      </div>
      <div class="switchTypes">
        <div class="switchTabs">
          <ul>
            <li
              :class="curOneClassIndex == indextab ? 'active' : ''"
              v-for="(tab, indextab) in switchTabs"
              style="width: auto; min-width: 154px; padding: 0 10px"
              :key="indextab"
              @click="switchsTab(tab.id, indextab)"
            >
              {{ tab.title }}
            </li>
          </ul>
          <div class="switchCons">
            <div
              class="typeIntroduce"
              v-for="(tab, indextab) in switchTabs"
              :key="indextab"
              v-show="curOneClassIndex == indextab"
            >
              {{ tab.info }}
            </div>
            <ul>
              <li
                v-for="(ele, index) in allType"
                :key="index"
                @click="allTypes(ele.types, index)"
                :class="curTwoClassIndex == index ? 'active' : ''"
              >
                {{ ele.name }}
              </li>
            </ul>
            <div class="typesCard">
              <div
                class="typesCardInfos"
                v-for="(card, indexCard) in typeCard"
                :key="indexCard"
              >
                <div class="cardNav">
                  <div class="cardNavLeft">
                    <h1>{{ card.title }}</h1>
                    <div>Passage{{ card.count }}</div>
                  </div>
                  <div class="cardNavRight">
                    <img
                      src="../../assets/questionBank/questionCardIcon.png"
                      v-show="card.already == 0"
                    />
                    <el-progress
                      type="circle"
                      :percentage="card.already / card.count"
                      :show-text="false"
                      :width="40"
                      v-show="card.already <= card.count && card.already > 0"
                    ></el-progress>
                    <!-- <el-progress type="circle" :percentage="card.count" :show-text="false" :width="40" v-show="card.already <= card.count && card.already > 0"></el-progress> -->
                  </div>
                </div>
                <div class="cardContent" v-show="card.already == 0">
                  <div class="cardContentBtn" @click="startSystem(card)">
                    开始练习
                  </div>
                  <div>做题人数：{{ card.peoplenum }}</div>
                  <div>平均分：{{ card.average }}</div>
                </div>
                <!-- <div class="cardContent" v-show="card.already < card.count && card.already > 0"> -->
                <div
                  class="cardContent"
                  v-show="card.already <= card.count && card.already > 0"
                >
                  <div
                    class="switchBtns"
                    :class="btns == eles.type ? 'activeBtns' : ''"
                    v-for="(eles, indexs) in switchTab"
                    :key="indexs"
                    @click="switchTabBtn(eles.type, card.id, card)"
                  >
                    {{ eles.name }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api/dryRun.js";
import headers from "../../components/header.vue";
import searchNav from "../../components/searchNav.vue";
export default {
  components: {
    searchNav,
    headers,
  },
  data() {
    return {
      navCodes: require("@/assets/login/whiteCode.png"),
      headerIcon: require("@/assets/bottom/bottomIcon.png"),
      allType: [
        {
          name: "全部",
          types: 0,
        },
        {
          name: "已做",
          types: 1,
        },
        {
          name: "未做",
          types: 2,
        },
      ],
      //模考建议
      dryRun: [
        {
          title: null,
        },
      ],
      //试卷列表
      typeCard: [
        {
          title: null,
        },
      ],
      //模考tab
      switchTabs: [],
      btns: 1,
      //card按钮
      switchTab: [
        {
          name: "查看结果",
          type: 1,
        },
        {
          name: "重新练习",
          type: 2,
        },
        {
          name: "继续练习",
          type: 3,
        },
      ],
      params: {
        s_id: "",
        type: "",
      },
      curOneClassIndex: 0,
      curTwoClassIndex: 0,
    };
  },
  methods: {
    goSearch() {
      this.$router.push("/searchMatter");
    },
    switchsTab(types, index) {
      this.curOneClassIndex = index;
      this.curTwoClassIndex = 0;
      this.params.type = 0;
      this.params.s_id = types;
      this.getTestList();
    },
    allTypes(types, index) {
      this.curTwoClassIndex = index;
      this.params.type = types;
      this.getTestList();
    },
    //未做完（做完）的按钮
    switchTabBtn(type, id, data) {
      console.log("0000000" + data);
      this.btns = type;
      console.log("111" + data.title);
      sessionStorage.setItem("m_id", id);
      sessionStorage.setItem("curId", data.cur_id);
      sessionStorage.setItem("title", data.title);
      sessionStorage.setItem("examType", "模考");
      switch (type) {
        case 1:
          sessionStorage.removeItem("choice");
          sessionStorage.removeItem("isFirst");
          return this.$router.push("/scheduleMatter");
        case 2:
          sessionStorage.removeItem("choice");
          sessionStorage.removeItem("isFirst");
          return this.$router.push(`/examinContent/examinatStart/${id}`);
        // case 3 : 需要知道下一题是什么类型，然后跳转到相应题型的页面中去继续答题接口会返回题数据
        case 3:
          // sessionStorage.removeItem('choice')
          sessionStorage.removeItem("isFirst");
          // return alert('继续')
          const fifthRadio = data.type;
          const path = [
            "/singleChoice",
            "/completion",
            "/doubleChoice",
            "/singleChoiceBoolean",
            "/examinContent/systemRead",
            "/imageAnalysis",
            "/table",
            "/reasoning",
            "/choice",
          ];
          if (fifthRadio >= 1 && fifthRadio <= 9) {
            this.$router.push({
              path: path[fifthRadio - 1],
              query: {
                id: data.cur_id,
                m_id: id,
              },
            });
          } else {
            this.$message.error("题目类型错误");
            return;
          }
      }
    },
    //开始练习按钮
    startSystem(card) {
      sessionStorage.setItem("m_id", card.id);
      sessionStorage.setItem("examType", "模考");
      sessionStorage.setItem("title", card.title);
      sessionStorage.removeItem("review");
      this.$router.push(`/examinContent/examinatStart/${card.id}`);
    },
    //获取卷子列表
    getTestList() {
      api.getPraList(this.params).then((res) => {
        this.typeCard = res.data.data.mockexam;
        this.dryRun = res.data.data.info;
        this.switchTabs = res.data.data.suits;
        console.log(res, "模考卷子列表");
      });
    },
  },
  mounted() {
    if (localStorage.getItem("token")) {
      this.getTestList();
    } else {
      this.$router.push("/login");
    }
  },
  updated() {
    this.$refs.header.headerBack = {
      backgroundColor: "#fff",
    };
    this.$refs.header.herderTits = {
      color: "rgb(102,102,102)",
    };
    this.$refs.header.headerIcon = require("@/assets/home/headerNav.png");
  },
};
</script>

<style scoped>
@import url("../../assets/css/questionbank.css");
</style>



// WEBPACK FOOTER //
// src/view/questionBank/questionbank.vue